import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {
  CheckinForm,
  SEARCH_TYPE,
  START_FROM_HOME,
  TAB,
  TripsRequest
} from '../../models';
import { ViewTripHeader } from '../../models/interfaces/trip-detail.interfaces';

@Component({
  selector: 'idp-my-trip-detail',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule],
  templateUrl: './trip-detail.component.html',
  styleUrls: ['./trip-detail.component.scss']
})
export class MyTripDetailComponent {
  @Input() trip!: ViewTripHeader | null;

  @Output() viewTripDetailsButton: EventEmitter<TripsRequest> =
    new EventEmitter<TripsRequest>();

  @Output() checkInButton: EventEmitter<CheckinForm> =
    new EventEmitter<CheckinForm>();

  // TODO: viewDetailsLink uses bau findPnr.action, needs to be updated
  viewTripDetails(): void {
    if (this.trip) {
      const request: TripsRequest = {
        recordLocator: this.trip.confirmationNo || '',
        firstName: this.trip.firstName,
        lastName: this.trip.lastName,
        searchType: TAB.CONFIRMATION_NO
      };

      this.viewTripDetailsButton.emit(request);
    }
  }

  checkIn(): void {
    if (
      this.trip?.confirmationNo &&
      this.trip?.checkinStatus?.departureAirport
    ) {
      const request: CheckinForm = {
        confirmationNumber: this.trip.confirmationNo,
        departureAirport: this.trip.checkinStatus.departureAirport,
        startFrom: START_FROM_HOME,
        searchType: SEARCH_TYPE
      };
      this.checkInButton.emit(request);
    }
  }
}
